import { SidebarMenuItem } from '@/components/sv/sidebar'
import { Skeleton } from '@/components/ui/skeleton'

export const SidebarUserNavFallback = () => (
  <SidebarMenuItem>
    <div className="flex items-center gap-2 p-2 h-12">
      <Skeleton className="size-8 rounded-lg shrink-0" />
      <div className="grid flex-1 gap-1 group-data-[collapsible=icon]:hidden">
        <Skeleton className="h-3.5 w-24" />
        <Skeleton className="h-3 w-32" />
      </div>
    </div>
  </SidebarMenuItem>
)
